<template>
  <div class="km__modules__text--edit">
    <button
        @click="$emit('closeOneLevel')"
        class="km__button--back" type="button" name="back">
      back
    </button>
    <button
        @click="$emit('endTextEditing')"
        class="km__button--close" type="button" name="close">
      close
    </button>
    <div class="action__edit">
      <div v-if="currentSelOb !== null" class="action__input__wrapper">
        <div id="inputNew" class="action__input--new">
          <input
              :value="currentSelOb.value"
              ref="textvalueinput"
              @input="changeTextvalue(textvalueinput.value, $event.target)"
              class="km__input--standard textedit" type="text" name="textedit"
              @focus="$event.target.select()"
          >
          <button
              @click="deleteItem"
              class="km__button--icon delete" type="button" name="delete">
            delete
          </button>
        </div>
        <div class="action__tackletwill__wrapper" v-if="isTackleTwillMoeglich">
          <div class="tw__input__wrapper">
            <input id="tw" type="checkbox" :checked="currentSelOb.hasTackleTwill" @change="onHasTackleTwillChange(($event.target as HTMLInputElement).checked)">
            <label
                class="tw__input__layout"
                :class="{ active: currentSelOb.hasTackleTwill }"
                for="tw">
            </label>
          </div>
          <div class="tw__label">Tackle Twill</div>
          <div class="tw__info__button">
            <img src="/src/assets/info.svg" alt="info" />
          </div>
        </div>
      </div>
      <div v-if="currentSelOb !== null" class="action__buttons__wrapper">
        <ul class="km__list--modules">
          <li class="km__list__element">
            <span class="km__label typeface">Icon</span>
            <button
                @click="openTypeface"
                id="typeface"
                class="km__button--standard typeface" type="button" name="typeface">
              ABC
            </button>
          </li>
          <TextEditColorPickerButton
              :background-color="textColorValue"
              @click="openFontColor"
              idAndName="fontcolor" :additionalClasses="['fontcolor']" text="Farbe"
          />
          <TextEditColorPickerButton
              :background-color="outlineColorValue" @click="openFontOutline" idAndName="outlinecolor"
              :additionalClasses="['outlinecolor']" text="OutlineFarbe" :hasOutline="hasOutline"
          />

          <li class="km__list__element">
            <span class="km__label fontsize">Icon</span>
            <TextEditSmallButton iconclass="minus" @click="sendSizeChange('down')"/>
            <TextEditSmallButton iconclass="plus" @click="sendSizeChange('up')"/>
          </li>
          <li class="km__list__element">
            <span class="km__label textlayer">Icon</span>
            <TextEditSmallButton v-if="!availableZOrders.up" disabled="true" iconclass="up" @click="zOrderUp"/>
            <TextEditSmallButton v-else iconclass="up" @click="zOrderUp"/>
            <TextEditSmallButton v-if="!availableZOrders.down" disabled="true" iconclass="down" @click="zOrderDown"/>
            <TextEditSmallButton v-else iconclass="down" @click="zOrderDown"/>
          </li>
          <li class="km__list__element">
            <span class="km__label stroke">Icon</span>
            <TextEditSmallButton v-if="!outlineThicknessChangeAllowed.down" disabled="true" iconclass="minus"
                                 @click="fontOutlineDecrease"/>
            <TextEditSmallButton v-else iconclass="minus" @click="fontOutlineDecrease"/>
            <TextEditSmallButton v-if="!outlineThicknessChangeAllowed.up" disabled="true" iconclass="plus"
                                 @click="fontOutlineIncrease"/>
            <TextEditSmallButton v-else iconclass="plus" @click="fontOutlineIncrease"/>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>

import TextEditSmallButton from "@km/components/text/TextEditSmallButton.vue";
import TextEditColorPickerButton from "@km/components/text/TextEditColorPickerButton.vue";
import {CommonSelObInteractions} from "@km/js/CommonSelObInteractions";
import {ModuleTextEditFunctions} from "@km/components/text/ModuleTextEditFunctions";
import {computed, onUnmounted, ref, Ref, watchEffect} from "vue";
import {SELOBEVENTNAMES} from "@k/global/GlobalEventnames";

import {EventListener, EventVerteiler} from "@k/global/eventVerteiler";
import {useStore} from "vuex";
import {
  AnimationWaitingForTargetFactory,
  KeyFrameTargetValues,
  UpDownAnimationWithDelay
} from "@km/animations/animationFactory";
import {setWatchToAnimateOnStatechange} from "@km/js/animater";
import {TEXTMODULE_POSSIBLE_STATES} from "@km/components/text/ModuleTextAnimations";
import {useModuleTextOpenStatusStore} from "@km/store/frontendstate/useModuleTextOpenState";
import textEditWrapper from "@km/components/text/textEditWrapper";
import {SelectableObject} from "@k/js/selectableObjects";

function getBaseAninmation() {
  return {
    animation: AnimationWaitingForTargetFactory.getUpDownAnimation('.km__modules__text--edit'),
    keyframes: new KeyFrameTargetValues(0, 200)
  };
}

function getActionEditAnimation() {
  return {
    animation: AnimationWaitingForTargetFactory.getAnimation(
        ".km__modules__text--edit .action__edit",
        (targetWithDelay) =>
            new UpDownAnimationWithDelay(0.5, (targetWithDelay as {
              targetValue,
              delay
            }).targetValue, (targetWithDelay as { targetValue, delay }).delay)),
    keyframes: new KeyFrameTargetValues(
        {targetValue: 0, delay: 0.2},
        {targetValue: 0, delay: 0.2},
        {targetValue: 50, delay: 0})
  }
}

const emojiRegex = /[\u{1F600}-\u{1F64F}]|[\u{1F300}-\u{1F5FF}]|[\u{1F680}-\u{1F6FF}]|[\u{1F1E0}-\u{1F1FF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]|[\u{1F900}-\u{1F9FF}]|[\u{1F018}-\u{1F270}]|[\u{238C}-\u{2454}]|[\u{20D0}-\u{20FF}]|[\u{FE00}-\u{FE0F}]|[\u{1F900}-\u{1F9FF}]|[\u{1FA00}-\u{1FA6F}]|[\u{1FA70}-\u{1FAFF}]|[\u{2190}-\u{21FF}]|[\u{2300}-\u{23FF}]|[\u{2B00}-\u{2BFF}]|[\u{25A0}-\u{25FF}]|[\u{24C2}-\u{1F251}]/gu;

const props = defineProps({
  currentSelOb: Object
})

ModuleTextEditFunctions.init(props);
const eventListener = new EventListener();
const store = useStore();

const isTackleTwillMoeglich =  computed(() =>store.getters["ModelStore/getCurrentOwayoProduct"]?.TackleTwillMoeglich);
const onHasTackleTwillChange = (checked: boolean) => commonFunctions.toggleTackleTwill(props.currentSelOb as SelectableObject, checked);

const openStatusStore = useModuleTextOpenStatusStore();
const baseAnimation = getBaseAninmation();
const animationActionEdit = getActionEditAnimation();
setWatchToAnimateOnStatechange(
    baseAnimation.animation,
    baseAnimation.keyframes,
    () => openStatusStore.getEditState
);
setWatchToAnimateOnStatechange(
    animationActionEdit.animation,
    animationActionEdit.keyframes,
    () => openStatusStore.getAction_editState
);
onUnmounted(() => EventVerteiler.unsubscribe(eventListener));
eventListener.addEventListener([SELOBEVENTNAMES.SELECTED, "objectInteractionEndingEvent"], () => ModuleTextEditFunctions.isOutlineThicknessChangeAllowed());
const commonFunctions = new CommonSelObInteractions();
const textvalueinput = ref("");

const outlineThicknessChangeAllowed = ModuleTextEditFunctions.outlineThicknessChangeAllowed as Ref<{ up, down }>;
const zOrderUp = () => commonFunctions.zOrderUp();
const zOrderDown = () => commonFunctions.zOrderDown();
const deleteItem = () => commonFunctions.deleteItem(props.currentSelOb);
const availableZOrders = commonFunctions.availableZOrders.value;
const sendSizeChange = (upOrDown) => commonFunctions.sendSizeChange(upOrDown, props.currentSelOb);
const textColorValue = ModuleTextEditFunctions.textColorValue;
const outlineColorValue = ModuleTextEditFunctions.outlineColorValue;
const hasOutline = ModuleTextEditFunctions.hasOutline;
//const changeTextvalue = ModuleTextEditFunctions.changeTextvalue;
const changeTextvalue = (value: string, inputElement?) => {
  if (emojiRegex.test(value)) {
    value = value.replace(emojiRegex, '');
    EventVerteiler.broadcast("displayHintEventToBeTranslated", {message:"konf_noEmojiesAllowedInText"});
    if (inputElement) {
      inputElement.value = value;
    }
  }
  textEditWrapper.addChange(value);
}
const openTypeface = () => openStatusStore.setCurrentState(TEXTMODULE_POSSIBLE_STATES.typeface);
const openFontColor = () => openStatusStore.setCurrentState(TEXTMODULE_POSSIBLE_STATES.color);
const openFontOutline = () => openStatusStore.setCurrentState(TEXTMODULE_POSSIBLE_STATES.colorOutline);
const fontOutlineDecrease = ModuleTextEditFunctions.fontOutlineDecrease;
const fontOutlineIncrease = ModuleTextEditFunctions.fontOutlineIncrease;


</script>

<style lang="scss" scoped>
@import '../../scss/style';

/* ***********************************
*  TEXT EDIT
*  - Buttons
*  - Label
*  - Input
*  - Input wrapper
*  - Action Buttons wrapper
*  - Layer wrapper
* ********************************** */

/* ***********************************
*	TEXT EDIT - Buttons
* ********************************** */
.km__button {
  &--icon {
    &.delete {
      position: absolute;
      top: 2px;
      right: 12px;
      width: 28px;
      height: 28px;
    }
  }

  &--standard {

    &.typeface {
      width: 60px;
      background-color: $color-white;
      display: inline-block;
      position: relative;
      font-weight: 600;
      text-transform: uppercase;

      &.active {
        &:after {
          @include color-active;
        }
      }
    }

    &.fontcolor,
    &.outlinecolor {
      @include hide-text;
    }
  }
}

/* ***********************************
*	TEXT EDIT - Label
* ********************************** */
.km__label {
  &.typeface {
    background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMy4wLjQsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iRWJlbmVfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxMDAgMTAwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojMzMzMzMzO30NCjwvc3R5bGU+DQo8Zz4NCgk8Zz4NCgkJPHBhdGggY2xhc3M9InN0MCIgZD0iTTgwLjQsNzlINTMuNnYtMy42bDAuMSwwYzIuOC0wLjQsNC4xLTAuOSw0LjYtMS42YzAuNS0wLjgsMC4xLTItMC40LTMuN2MtMC45LTIuNy0yLjMtNi42LTMuNi0xMEgzNy40DQoJCQljLTAuMiwwLjYtMC41LDEuMy0wLjcsMmMtMC44LDIuMy0xLjcsNC42LTIuMyw2LjZjLTAuOCwyLjMtMC44LDMuNy0wLjIsNC42YzAuOCwxLjMsMywxLjcsNy4zLDIuMWwwLjIsMFY3OUgxOS42di0zLjZsMC4xLDANCgkJCWM1LjUtMC43LDYuOC0xLjUsOS44LTguOEw0Ny44LDIxbDUuNSwwLjJsMCwwLjFjMy45LDEwLjUsOCwyMC44LDExLjksMzAuOGMxLjgsNC41LDMuNiw5LjIsNS40LDEzLjhjMy4zLDguMyw0LjEsOC43LDkuNiw5LjQNCgkJCWwwLjEsMFY3OXogTTM5LjEsNTUuMmgxMy41bC02LjUtMThjLTAuMywwLjktMC43LDEuNy0xLDIuNkM0Mi45LDQ1LDQwLjksNDkuOSwzOS4xLDU1LjJ6Ii8+DQoJPC9nPg0KPC9nPg0KPC9zdmc+DQo=');
  }

  &.fontsize {
    background-image: url('data:image/svg+xml;base64,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');
  }

  &.textlayer {
    background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMy4wLjQsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iRWJlbmVfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxMDAgMTAwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojRkZGRkZGO3N0cm9rZTojMzMzMzMzO3N0cm9rZS13aWR0aDozLjk4MzU7c3Ryb2tlLW1pdGVybGltaXQ6MTA7fQ0KPC9zdHlsZT4NCjxnPg0KCTxnPg0KCQk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNNDguOSw4My4yYzAuNywwLjQsMS43LDAuNCwyLjQsMGwzMC4zLTE4LjljMi4yLTEuNCwyLjEtMy41LTAuMS00LjdMNTEuMSw0My4yYy0wLjctMC40LTEuOC0wLjQtMi41LDANCgkJCUwxOC41LDU5LjZjLTIuMywxLjItMi4zLDMuNC0wLjEsNC43TDQ4LjksODMuMnoiLz4NCgk8L2c+DQoJPGc+DQoJCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik00OC45LDcwYzAuNywwLjQsMS43LDAuNCwyLjQsMGwzMC4zLTE4LjljMi4yLTEuNCwyLjEtMy41LTAuMS00LjdMNTEuMSwzMGMtMC43LTAuNC0xLjgtMC40LTIuNSwwTDE4LjUsNDYuNA0KCQkJYy0yLjMsMS4yLTIuMywzLjQtMC4xLDQuN0w0OC45LDcweiIvPg0KCTwvZz4NCgk8Zz4NCgkJPHBhdGggY2xhc3M9InN0MCIgZD0iTTQ4LjksNTYuOGMwLjcsMC40LDEuNywwLjQsMi40LDBsMzAuMy0xOC45YzIuMi0xLjQsMi4xLTMuNS0wLjEtNC43TDUxLjEsMTYuN2MtMC43LTAuNC0xLjgtMC40LTIuNSwwDQoJCQlMMTguNSwzMy4xYy0yLjMsMS4yLTIuMywzLjQtMC4xLDQuN0w0OC45LDU2Ljh6Ii8+DQoJPC9nPg0KPC9nPg0KPC9zdmc+DQo=');
  }

  &.stroke {
    background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMy4wLjQsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iRWJlbmVfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxMDAgMTAwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojMzMzMzMzO30NCjwvc3R5bGU+DQo8cmVjdCB4PSIxNi41IiB5PSI1OS4xIiBjbGFzcz0ic3QwIiB3aWR0aD0iNjciIGhlaWdodD0iMTIuNSIvPg0KPHJlY3QgeD0iMTYuNSIgeT0iNDIuNCIgY2xhc3M9InN0MCIgd2lkdGg9IjY3IiBoZWlnaHQ9IjcuNSIvPg0KPHJlY3QgeD0iMTYuNSIgeT0iMjguNCIgY2xhc3M9InN0MCIgd2lkdGg9IjY3IiBoZWlnaHQ9IjQuOCIvPg0KPC9zdmc+DQo=');
  }
}

/* ***********************************
*	TEXT EDIT - Input
* ********************************** */
.km__input {
  &--standard {
    &.textedit {
      width: calc(100% - 10px);
      border: 2px solid $color-input-border;
    }
  }
}

/* ***********************************
*	TEXT EDIT - Input wrapper
* ********************************** */
.km__modules__text--edit {
  .action__input__wrapper {
    width: calc(100% - 14px);
    display: flex;
    flex-direction: row;
    margin: 0 auto 30px auto;

    .action__input--new {
      position: relative;
      width: 50%;
      padding-left: 20px;
    }
  }
}

/* ***********************************
*	TEXT EDIT - Action Buttons wrapper
* ********************************** */
.km__modules__text--edit {
  .action__buttons__wrapper {
    .km__list--modules {
      display: flex;
      flex-wrap: wrap;

      .km__list__element {
        width: 33.333333%;
        display: flex;
        flex-direction: row;
        margin-bottom: 25px;
        position: relative;
      }
    }
  }
}

/* ***********************************
*	TEXT EDIT - Layer wrapper
* ********************************** */
.km__modules__text--edit {
  position: fixed;
  height: 200px;
  width: 100%;
  bottom: $cta-height;
  left: 0;
  z-index: 99;
  background: $color-white;
  padding: 40px 10px 20px 10px;
  transform: translate(0, 200px);
}

/* ***********************************
*	TEXT EDIT - Tackletwill
* ********************************** */
.tw__input__wrapper {
  position: relative;

  #tw {
    visibility: hidden;
  }

  .tw__input__layout {
    border: 2px solid #C0BEBF;
    border-radius: 50%;
    cursor: pointer;
    left: 0;
    position: absolute;
    top: 0;
    width: 22px;
    height: 22px;

    &.active {
      background-image: url(data:image/svg+xml;base64,PHN2ZyBpZD0iS29tcG9uZW50ZV80NV8xNSIgZGF0YS1uYW1lPSJLb21wb25lbnRlIDQ1IOKAkyAxNSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMTMuMTE3IiBoZWlnaHQ9IjEwLjMwNCIgdmlld0JveD0iMCAwIDEzLjExNyAxMC4zMDQiPg0KICA8ZyBpZD0iR3J1cHBlXzMxNCIgZGF0YS1uYW1lPSJHcnVwcGUgMzE0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDI1LjMzIC0yNDcuODQ4KSI+DQogICAgPHBhdGggaWQ9IlBmYWRfMjczIiBkYXRhLW5hbWU9IlBmYWQgMjczIiBkPSJNNDMwLjA0NywyNTguMTUybC00LjcxNy00LjcxOCwxLjktMS45LDIuODE0LDIuODE1LDYuNS02LjUsMS45LDEuOVoiIGZpbGw9IiMyNDI0MjQiLz4NCiAgPC9nPg0KPC9zdmc+DQo=);
      background-repeat: no-repeat;
      background-position: center;
      background-size: 10px auto;
    }
  }
}

.action__tackletwill__wrapper {
  position: relative;
  width: 50%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.tw__label {
  font-size: 15px;
  padding-top: 3px;
  margin-left: 10px;
  color: black;
}

.tw__info__button {
  width: 25px;
  margin-right: 5px;
  margin-left: 12px;

  img {
    position: relative;
    top: 2px;
  }
}
</style>
